import { useEffect, useState } from "react";
import { BillingPeriodUnit, AccessType } from "services/graphql";
import { usePlans, useCoupon } from "hooks/Checkout";
import { usePrimarySubscription } from "hooks/Subscriptions/usePrimarySubscription";
import { INTRO_OFFER_COUPON_ID } from "constants/index";

export function useIntroOfferCoupon() {
  const { data: plansData, loading: fetchingPlans } = usePlans();
  const { primarySubscription } = usePrimarySubscription();
  const [currentPlan, setCurrentPlan] = useState<
    typeof plansData.plans[0] | null
  >(null);

  const { plans } = plansData || {};

  // Update currentPlan when plans change
  useEffect(() => {
    if (!plans) {
      return;
    }

    const standardYearlyPlan = plans.find(
      plan =>
        plan.accessType === AccessType.Standard &&
        plan.periodUnit === BillingPeriodUnit.Year
    );

    if (standardYearlyPlan?.id !== currentPlan?.id) {
      setCurrentPlan(standardYearlyPlan ?? null);
    }
  }, [plans, currentPlan?.id]);

  const {
    couponSuccess,
    couponEstimate,
    loadingCouponEstimate,
    hasCalledCheckoutEstimate,
  } = useCoupon(currentPlan, INTRO_OFFER_COUPON_ID);

  const isEligibleForIntroOffer = couponSuccess && !primarySubscription;

  return {
    isLoadingIntroOffer:
      !hasCalledCheckoutEstimate || fetchingPlans || loadingCouponEstimate,
    isEligibleForIntroOffer,
    standardYearlyPlan: currentPlan,
    introOfferCouponId: INTRO_OFFER_COUPON_ID,
    couponEstimate,
    couponSuccess,
  };
}
